/**
 * 포인트 정책 — 프론트엔드 정본
 * 2026-05 개편: 1P = 1원 환산, 일일 통합 상한 200P, 1년 만료, 교환 최소 보유 5,000P
 * 활동 보상 값은 백엔드 정본과 동기화 (constants/points.ts)
 */
export const POINT_POLICY = {
  // 적립
  write_post: 20,
  write_post_premium: 30,
  write_comment: 5,
  write_comment_premium: 8,
  write_diary: 7,
  checkin: 10,
  checkin_streak_7: 50,
  checkin_streak_30: 300,
  signup_bonus: 200,
  referral_referrer: 100,
  referral_referee: 50,

  // 상한 — 통합 200P/일 (가입 보너스·친구 추천 제외)
  maxDailyPoints: 200,

  // 교환
  minExchange: 500,
  minExchangeBalance: 5000,

  // 만료
  expireMonths: 12,
  expireNotifyDaysBefore: 30,
} as const;

export const PREMIUM_PRICE = 2900;
